import { __rest } from './external/.pnpm/tslib@2.3.1/external/tslib/tslib.es6.js';
import { _mapValues, _isPlainObject } from '@felte/common';

function deepSetTouched(obj, value) {
    return _mapValues(obj, (prop) => {
        if (_isPlainObject(prop))
            return deepSetTouched(prop, value);
        if (Array.isArray(prop)) {
            if (prop.length === 0 || prop.every((p) => typeof p === 'string'))
                return value;
            return prop.map((p) => {
                const _a = deepSetTouched(p, value), field = __rest(_a, ["key"]);
                return field;
            });
        }
        return value;
    });
}

export { deepSetTouched };
//# sourceMappingURL=deep-set-touched.js.map
